import { ref } from 'vue';
import { Cookie } from '@vue-util/cookie';
import $http from '@vue-util/http';
import { DELIVERY_AND_PICKUP_V2 } from '../constants/delivery-and-pickup';

// TODO remove variables outside of the scope
const zipLocationNumbers = new Map();
const locationZipNumbers = new Map();

export const isLoading = ref(false);

export const clearMapCache = () => {
  zipLocationNumbers.clear();
  locationZipNumbers.clear();
};

const api = async (url, params) => {
  let data = {};
  try {
    isLoading.value = true;
    // TODO replace with $fetch
    const response = await $http.get(url, {
      maxRedirects: 1,
      params: {
        xapi: 1,
        ...params,
      },
      headers: {
        'x-macys-clientid': 'Navapp',
      },
    });
    /* istanbul ignore next */
    if (response) {
      ({ data } = response);
    }
  } catch (error) {
    data = {};
    console.error('Error: ', error);
    throw error;
  } finally {
    isLoading.value = false;
  }
  return data;
};

export function getPickupStore() {
  const bopsStoreLocationNumber = Cookie.get('CSL');
  return bopsStoreLocationNumber ? Number(bopsStoreLocationNumber) : null;
}

export function getCommonStore() {
  if (import.meta.client) {
    const commonstorelocationJson = window.localStorage.getItem('commonstorelocation');
    const commonstorelocation = commonstorelocationJson ? JSON.parse(commonstorelocationJson) : null;
    return commonstorelocation;
  }
}

export function getPickupStoreZip() {
  let bopsZip = null;
  /* istanbul ignore next */
  if (import.meta.client) {
    const commonstorelocation = getCommonStore();
    bopsZip = commonstorelocation && commonstorelocation.addresses ? commonstorelocation.addresses[0]?.zipCode : null;
  }
  return bopsZip || null;
}

export function getZipCode() {
  const sddZip = Cookie.get('BTZIPCODE', 'MISCGCs') || Cookie.get('USERPC', 'MISCGCs');
  return sddZip || null;
}

export async function getLocationInfoByZipCode(zipCode) {
  const url = `/api/store/v2/stores/shipTo/${zipCode}?xapi=1&_fields=locationNumber&shipMethod=SDD&httpMethod=GET`;
  let info = null;
  try {
    const response = await $fetch(url, {
      headers: {
        'x-macys-clientid': 'Navapp',
      },
    });

    info = response?.stores?.store?.[0];
  } catch (error) {
    console.error(`get location info by zip code ${zipCode} error:`, error);
  }

  return info;
}

export async function getZipLocationInfo(zipCode) {
  let locationNumber = null;
  /* istanbul ignore next */
  if (zipCode) {
    // looking in a cache
    locationNumber = zipLocationNumbers.get(zipCode);
    /* istanbul ignore next */
    if (!locationNumber) {
      let info = null;
      // request location number from API
      const url = `/api/store/v2/stores/shipTo/${zipCode}`;
      const response = await api(url, {
        _fields: 'locationNumber',
        shipMethod: 'SDD',
        httpMethod: 'GET',
      });
      info = response?.stores?.store;
      info = info ? info[0] : null;
      locationNumber = info ? info.locationNumber : null;
      /* istanbul ignore else */
      if (locationNumber) {
        zipLocationNumbers.set(zipCode, locationNumber);
      }
    }
  }

  return locationNumber;
}

export async function getZipCodeByLocation(locationNumber) {
  let zipCode = null;
  /* istanbul ignore else */
  if (locationNumber) {
    // looking in a cache
    zipCode = locationZipNumbers.get(locationNumber);
    /* istanbul ignore next */
    if (!zipCode) {
      let info = null;
      // request location number from API
      const url = `/api/store/v2/stores/${locationNumber}`;
      const response = await api(url, {
        _fields: 'locationNumber,address',
        shipMethod: 'SDD',
        httpMethod: 'GET',
      });
      info = response?.stores?.store;
      info = info ? info[0] : null;
      zipCode = info ? info?.address?.zipCode : null;
      /* istanbul ignore else */
      if (zipCode) {
        locationZipNumbers.set(locationNumber, zipCode);
      }
    }
  }

  return zipCode;
}

export async function getLocationsInfo(locationIds, fields = []) {
  let info = null;
  const ids = locationIds.filter((v) => v);
  /* istanbul ignore next */
  if (ids) {
    const url = `/api/store/v2/stores/${ids.join(',')}`;
    const response = await api(url, {
      _fields: `bopsFreePickUpMessage,curbsideFreePickUpMessage,sddMessage,locationNumber,name,address${fields.length ? ',' + fields.join(',') : ''}`,
      shipMethod: 'SDD',
      httpMethod: 'GET',
    });
    info = response?.stores?.store;
  }
  return info || null;
}

export async function getStoreInventoryInfo(locationIds) {
  let info = null;
  const ids = locationIds.filter((v) => v);
  /* istanbul ignore next */
  if (ids) {
    const url = '/api/catalog/v2/inventories/storeinventory/eligiblestores';
    const response = await api(url, {
      locationNumber: ids.join(','),
      shipMethod: 'SDD',
      httpMethod: 'GET',
    });
    info = response?.storeInventories?.storeInventory;
  }

  return info || null;
}

export const copyFacet = (srcFacet) => {
  const facet = { ...srcFacet };
  facet.values = facet.values.map((v) => ({ ...v }));
  facet.selectedValues = [...facet.selectedValues];
  return facet;
};

export const findFacetOption = (facet, type) => facet.values.find((v) => v.value.substring(0, type.length + 1) === `${type}=`);

export const isNotDeliveryAndPickupFacet = (facet) =>
  facet?.facetType !== 'DELIVERY_AND_PICKUP' && facet?.facetType !== 'BT_DELIVERY' && facet?.facetType !== DELIVERY_AND_PICKUP_V2;
